import { Component, input, output } from "@angular/core";
import { IonCol, IonGrid, IonRow } from "@ionic/angular/standalone";

import { BaseComponent } from "@mp/common/base/base.component";
import { UserEntity } from "@mp/common/entities/user.entity";
import { UserAvatarComponent } from "../user-avatar/user-avatar.component";

@Component({
    selector: "mp-user-chip",
    templateUrl: "user-chip.component.html",
    styleUrls: ["user-chip.component.scss"],
    imports: [IonGrid, IonRow, IonCol, UserAvatarComponent],
    host: {
        "[style.--hover-color]": "hoverColor()",
        "[class.is-hoverable]": "!!hoverColor() && clickable()",
        "[class.is-disabled]": "disabled()",
        "[class.is-detailed]": "detailed()"
    }
})
export class UserChipComponent extends BaseComponent {
    public readonly user = input.required<UserEntity>();
    public readonly clickable = input<boolean>(false);
    public readonly removable = input<boolean>(false);
    public readonly detailed = input<boolean>(false);
    public readonly disabled = input<boolean>(false);
    public readonly selected = input<boolean>(false);
    public readonly hoverColor = input<string | undefined>(undefined);

    public readonly clicked = output<string>();
    public readonly removed = output<string>();

    constructor() {
        super();
    }

    public onClicked(): void {
        if (this.disabled() || !this.clickable()) {
            return;
        }
        this.clicked.emit(this.user().id);
    }

    public onRemoved(id: string): void {
        this.removed.emit(id);
    }
}
